import svg4everybody from 'svg4everybody';
import $ from 'jquery';

svg4everybody();
window.$ = $;
window.jQuery = $;

require('slick-carousel');
require('moment');
require('jquery-date-range-picker/dist/jquery.daterangepicker.min.js');
require('masonry-layout/dist/masonry.pkgd');


// WEBPACK FOOTER //
// ./src/js/vendor.js